module.exports = __webpack_public_path__ + "img/img4.ad5cd06c.svg";